import { createFeatureSelector, createSelector } from '@ngrx/store';
import {ScreeningCriteriaState} from './screening-criteria.reducer';

export const selectScreeningCriteriaState = createFeatureSelector<ScreeningCriteriaState>('screeningCriteria');

export const selectCriteriaByProjectId = (projectId: number) =>
  createSelector(selectScreeningCriteriaState, (state) => state.criteriaByProject[projectId] || []);

export const selectAllProjectsWithCriteria = createSelector(
  selectScreeningCriteriaState,
  (state) => Object.keys(state.criteriaByProject)
);

export const selectSelectedScreeningCriteria = createSelector(
  selectScreeningCriteriaState,
  (state) => state.selectedCriteria
);

export const selectLoadingByProjectId = (projectId: number) =>
  createSelector(selectScreeningCriteriaState, (state) => state.loadingByProject[projectId] || false);

export const selectErrorByProjectId = (projectId: number) =>
  createSelector(selectScreeningCriteriaState, (state) => state.errorByProject[projectId] || null);
